<vx-dialog size="lg">
  <vx-dialog-header
    icon="play"
    [title]="
      'pages.settings.alerting.processors.details.simulation.title' | transloco
    "
    [description]="
      'pages.settings.alerting.processors.details.simulation.description'
        | transloco
    "
    [closeLabel]="'components.dialog.closeBtn' | transloco" />

  <app-alert-processor-simulation-result-viewer />

  <vx-dialog-footer>
    <vx-button variant="outline" tone="secondary" (click)="close()">
      {{
        'pages.settings.alerting.processors.details.simulation.close'
          | transloco
      }}
    </vx-button>
  </vx-dialog-footer>
</vx-dialog>
